/** Formata um valor monetário em pt-BR; cai para BRL se a moeda for inválida. */
export function formatMoney(value: number, currency = "BRL"): string {
    try {
        return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: currency || "BRL",
        }).format(value);
    } catch {
        return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
    }
}

/** Atalho para BRL (o caso mais comum). */
export const formatBRL = (value: number): string => formatMoney(value);

/**
 * Arredonda para 2 casas (centavos). Usar em toda aritmética de valores
 * exibidos: `number` binário acumula erro (0.1 + 0.2 ≠ 0.3) e um total somado
 * no front pode divergir do backend por um centavo.
 */
export function roundBRL(value: number): number {
    return Math.round((value + Number.EPSILON) * 100) / 100;
}
